import * as React from 'react';

interface AlertProps {
  readonly type?: 'default' | 'success' | 'error' | 'warning';
  readonly children?: any;
}

export function Alert(props: AlertProps) {
  const type = props.type ? props.type : 'default';

  return <div className={`alert ${type}`}>{props.children}</div>;
}



// WEBPACK FOOTER //
// ../node_modules/source-map-loader!./src/components/widgets/alert.tsx